module.exports = __webpack_public_path__ + "static/2-0105b31c5fe5d44e32336058fea934c5.png";